/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { Select } from 'components/Select';

export const AnnotationUserAutocomplete = ({
  setSelectedUserId,
  users,
  value,
}: {
  setSelectedUserId: (userId: CF.API.Collaborators.Collaborator) => void;
  users: CF.API.Collaborators.Collaborator[];
  value: any;
}): JSX.Element => {
  const options = users.map(({ user }) => ({
    value: user.id,
    name: `${user.first_name} ${user.last_name}`,
  }));

  const selectedOption = options.find((el) => el.value === value);
  const title = selectedOption ? selectedOption.name : 'Select User';

  const onChangeItem = useCallback(
    ({ value: selectValue }) => {
      setSelectedUserId(selectValue);
    },
    [users.length],
  );

  return <Select title={title} options={options} onChange={onChangeItem} />;
};
